<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'app',
    components: {},
    computed: {
        ...mapGetters({
            loggedIn: 'auth/isAuthenticated',
            tokenExpiration: 'auth/tokenExpiration',
        }),
    },
}
</script>

<style lang="scss">
// CoreUI Icons Set

/* Import Font Awesome Icons Set */
$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/scss/font-awesome.scss';

/* Import Simple Line Icons Set */
$simple-line-font-path: '~simple-line-icons/fonts/';
@import '~simple-line-icons/scss/simple-line-icons.scss';

/* Import Flag Icons Set */
@import '~flag-icon-css/css/flag-icon.min.css';

/* Import Bootstrap Vue Styles */
@import '~bootstrap-vue/dist/bootstrap-vue.css';

// Import Main styles for this application
@import 'assets/scss/style';

@import '~vue-multiselect/dist/vue-multiselect.min.css';
</style>
